<template>
  <div class="textarea">
    <textarea
      :title="label"
      :name="name"
      :id="`textarea-${id}`"
      ref="textarea"
      >{{ value }}</textarea
    >
    <label :for="`textarea-${id}`">{{ label }}</label>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';

  const id = Math.ceil(Math.random() * 100000);
  const textarea = ref(null);

  defineProps({
    name: {
      default: '',
      type: String,
    },

    label: {
      default: '',
      type: String,
    },

    value: {
      default: '',
      type: String,
    },
  });

  onMounted(() => {
    const el = textarea.value;

    el.addEventListener('input', () => {
      addActiveClass();
    });

    addActiveClass();

    function addActiveClass() {
      if (el.value !== '') {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    }
  });
</script>

<style lang="scss">
  @import '@sass/global/functions';

  .textarea {
    position: relative;
    min-width: fit-content;
    display: inline-block;
    margin-bottom: 16px;
    margin-right: 8px;

    textarea {
      @apply bg-white
        pt-6
        px-2
        pb-2
        border
        border-[#d1d1d1]
        focus-visible:border-[#969696]
        rounded
        outline-none
        min-h-[56px]
        w-full
        transition;

      &:focus,
      &.active {
        & + label {
          color: color(--primary);
          background: #fff;
          top: 1px;
          padding-top: 2px;
          left: 8px;
          transform: scale(0.8);
          max-width: 100%;
        }
      }
    }

    label {
      position: absolute;
      top: size(16);
      left: 8px;
      color: color(--grey-100);
      transform-origin: top left;
      transition: 0.2s ease-in-out;
      pointer-events: none;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      max-width: calc(100% - 16px);
    }
  }
</style>
